var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigmacolor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2803_294222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.51167 14.7889C6.84097 14.7889 7.91983 13.7101 7.91983 12.3808V9.97266H5.51167C4.18238 9.97266 3.10352 11.0515 3.10352 12.3808C3.10352 13.7101 4.18238 14.7889 5.51167 14.7889Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10352 7.56439C3.10352 6.23511 4.18238 5.15625 5.51167 5.15625H7.91983V9.97247H5.51167C4.18238 9.97253 3.10352 8.89367 3.10352 7.56439Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10352 2.74798C3.10352 1.4187 4.18238 0.339844 5.51167 0.339844H7.91983V5.15607H5.51167C4.18238 5.15607 3.10352 4.07727 3.10352 2.74798Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91992 0.339844H10.3281C11.6574 0.339844 12.7362 1.4187 12.7362 2.74798C12.7362 4.07727 11.6574 5.15607 10.3281 5.15607H7.91992V0.339844Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7362 7.56439C12.7362 8.89368 11.6574 9.97253 10.3281 9.97253C8.99879 9.97253 7.91992 8.89368 7.91992 7.56439C7.91992 6.23511 8.99879 5.15625 10.3281 5.15625C11.6574 5.15625 12.7362 6.23511 12.7362 7.56439Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2803_294222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4487,
    height: 14.4487,
    fill: "white",
    transform: "translate(0.695312 0.339844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmacolor);
export default __webpack_public_path__ + "static/media/figmacolor.b1a1025e30e59c25e86bed726102a370.svg";
export { ForwardRef as ReactComponent };